var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#383D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0289 10.1021L14.6619 16.2965L10 21.3331H11.0495L15.1314 16.9237L18.4291 21.3331H22L17.1065 14.7902L21.446 10.1021H20.3965L16.6377 14.163L13.6004 10.1021H10.0296H10.0289ZM11.5718 10.875H13.2119L20.4557 20.5602H18.8156L11.5718 10.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialTwitter);
export default __webpack_public_path__ + "static/media/icon_social_twitter.644246864d598c3f42625367fdede303.svg";
export { ForwardRef as ReactComponent };